// extracted by mini-css-extract-plugin
module.exports = {"section":"l1cv0","title":"_3Ocqk","footer":"Vg314","readMore":"iisb9"};